import {z} from 'zod';

// Vehicle selection rules shared by campaigns and promotional photos (BE `CampaignFilterRequestBody`).
// An include list narrows to the listed values, `vehicleType` to one code, the ranges and
// `daysInStock` (greater-than) to numbers, `stockInDateFrom` to a date (on or after). An
// `excluded*` list rejects the listed values, and a vehicle without a value for that attribute is
// rejected too. `missing` names the attributes that must have no value on the vehicle. A value may
// not be both included and excluded: the BE answers 400 with the reason. Prices are integers in
// minor units.
export const CampaignFilterSchema = z.object({
  branchIds: z.array(z.string().uuid()).optional(),
  vehicleType: z.string().nullable().optional(),
  daysInStock: z.number().int().min(1).nullable().optional(),
  stockInDateFrom: z.string().nullable().optional(),
  mileageFrom: z.number().int().nullable().optional(),
  mileageTo: z.number().int().nullable().optional(),
  yearFrom: z.number().int().nullable().optional(),
  yearTo: z.number().int().nullable().optional(),
  priceFrom: z.number().nullable().optional(),
  priceTo: z.number().nullable().optional(),
  fuelTypes: z.array(z.string()).optional(),
  bodyStyles: z.array(z.string()).optional(),
  modelFamilies: z.array(z.string()).optional(),
  models: z.array(z.string()).optional(),
  makes: z.array(z.string()).optional(),
  vehicleConditions: z.array(z.string()).optional(),
  salePresetIds: z.array(z.string().uuid()).optional(),
  tagIds: z.array(z.string().uuid()).optional(),
  excludedMakes: z.array(z.string()).optional(),
  excludedModelFamilies: z.array(z.string()).optional(),
  excludedModels: z.array(z.string()).optional(),
  excludedBodyStyles: z.array(z.string()).optional(),
  excludedFuelTypes: z.array(z.string()).optional(),
  excludedVehicleConditions: z.array(z.string()).optional(),
  excludedVehicleTypes: z.array(z.string()).optional(),
  excludedBranchIds: z.array(z.string().uuid()).optional(),
  excludedSalePresetIds: z.array(z.string().uuid()).optional(),
  excludedTagIds: z.array(z.string().uuid()).optional(),
  // Attribute codes from `GET /dms/v1/vehicle-selection/attributes` (`supportsMissing`).
  missing: z.array(z.string()).optional(),
});
export type CampaignFilter = z.infer<typeof CampaignFilterSchema>;
